"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POSITION = exports.Components = void 0;

var _ContentItemThumbnail = require("../ContentItemThumbnail");

var Components = {
  contentItemThumbnail: _ContentItemThumbnail.ContentItemThumbnail
};
exports.Components = Components;
var POSITION = {
  x: 0,
  y: 0
};
exports.POSITION = POSITION;